import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Section from '@components/common/layout/Section'
import useNewsArticles from '@components/hooks/useNewsArticles'
import ScrollableContainer from '@components/revamp/ScrollableContainer'

import i18n from '@src/config/i18n'
import AnalyticsClient from '@src/utils/AnalyticsClient'

export default function NewsSection() {
  const { t } = useTranslation('revamp')
  const newsArticles = useNewsArticles()

  const locale = i18n.language

  const formattedArticles = useMemo(
    () =>
      [...newsArticles].map((article) => ({
        image: article.photo.asset.url,
        title: article.title[locale],
        description: article.description[locale],
        linkText: article.link[locale],
        linkUrl: article[`${locale}Href`],
        order: article.order,
      })),
    [locale, newsArticles]
  )

  return (
    <Section className='py-10 md3:py-28'>
      <h4 className='text-revamp-neutral-700 font-bold leading-none text-r-5xl mb-6'>
        {t('news')}
      </h4>
      <p className='text-r-2xl text-revamp-neutral-600 mb-12 leading-mid'>{t('newsText')}</p>
      <ScrollableContainer className='flex gap-5'>
        {formattedArticles.map(({ image, title, description, linkText, linkUrl }) => (
          <article
            key={`news-${title}`}
            className='rounded-lg bg-center bg-cover flex items-end'
            style={{
              backgroundImage: `url(${image})`,
              height: '500px',
              flex: '0 0 400px',
            }}
          >
            <div className='ml-4 mb-4 p-4 flex flex-col gap-2 bg-white w-2/3 rounded-lg'>
              <a
                rel='noreferrer'
                target='_blank'
                href={linkUrl}
                className='text-base text-revamp-blue flex items-center font-bold hover:underline leading-none'
                onClick={() => {
                  AnalyticsClient.track(`userAction`, {
                    interaction: {
                      event_name: `click`,
                      click_type: `newsArticleClick`,
                      link_text: title,
                      link_url: linkUrl,
                    },
                  })
                }}
              >
                <span>{linkText}</span>
              </a>
              <h5 className='text-xl font-bold leading-none'>{title}</h5>
              <p className='text-revamp-neutral-500 leading-none'>{description}</p>
            </div>
          </article>
        ))}
      </ScrollableContainer>
    </Section>
  )
}
